import { useState, useRef, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { ChevronDown } from "lucide-react";

const COUNTRY_CODES = [
  { code: "+1", flag: "\u{1F1FA}\u{1F1F8}", name: "US", label: "United States", maxDigits: 10 },
  { code: "+1", flag: "\u{1F1E8}\u{1F1E6}", name: "CA", label: "Canada", maxDigits: 10 },
  { code: "+52", flag: "\u{1F1F2}\u{1F1FD}", name: "MX", label: "Mexico", maxDigits: 10 },
  { code: "+44", flag: "\u{1F1EC}\u{1F1E7}", name: "GB", label: "United Kingdom", maxDigits: 10 },
  { code: "+49", flag: "\u{1F1E9}\u{1F1EA}", name: "DE", label: "Germany", maxDigits: 11 },
  { code: "+33", flag: "\u{1F1EB}\u{1F1F7}", name: "FR", label: "France", maxDigits: 9 },
  { code: "+34", flag: "\u{1F1EA}\u{1F1F8}", name: "ES", label: "Spain", maxDigits: 9 },
  { code: "+39", flag: "\u{1F1EE}\u{1F1F9}", name: "IT", label: "Italy", maxDigits: 10 },
  { code: "+55", flag: "\u{1F1E7}\u{1F1F7}", name: "BR", label: "Brazil", maxDigits: 11 },
  { code: "+57", flag: "\u{1F1E8}\u{1F1F4}", name: "CO", label: "Colombia", maxDigits: 10 },
  { code: "+51", flag: "\u{1F1F5}\u{1F1EA}", name: "PE", label: "Peru", maxDigits: 9 },
  { code: "+54", flag: "\u{1F1E6}\u{1F1F7}", name: "AR", label: "Argentina", maxDigits: 10 },
  { code: "+56", flag: "\u{1F1E8}\u{1F1F1}", name: "CL", label: "Chile", maxDigits: 9 },
  { code: "+86", flag: "\u{1F1E8}\u{1F1F3}", name: "CN", label: "China", maxDigits: 11 },
  { code: "+91", flag: "\u{1F1EE}\u{1F1F3}", name: "IN", label: "India", maxDigits: 10 },
  { code: "+81", flag: "\u{1F1EF}\u{1F1F5}", name: "JP", label: "Japan", maxDigits: 10 },
  { code: "+82", flag: "\u{1F1F0}\u{1F1F7}", name: "KR", label: "South Korea", maxDigits: 10 },
  { code: "+66", flag: "\u{1F1F9}\u{1F1ED}", name: "TH", label: "Thailand", maxDigits: 9 },
  { code: "+84", flag: "\u{1F1FB}\u{1F1F3}", name: "VN", label: "Vietnam", maxDigits: 9 },
  { code: "+63", flag: "\u{1F1F5}\u{1F1ED}", name: "PH", label: "Philippines", maxDigits: 10 },
  { code: "+62", flag: "\u{1F1EE}\u{1F1E9}", name: "ID", label: "Indonesia", maxDigits: 11 },
  { code: "+90", flag: "\u{1F1F9}\u{1F1F7}", name: "TR", label: "Turkey", maxDigits: 10 },
  { code: "+48", flag: "\u{1F1F5}\u{1F1F1}", name: "PL", label: "Poland", maxDigits: 9 },
  { code: "+380", flag: "\u{1F1FA}\u{1F1E6}", name: "UA", label: "Ukraine", maxDigits: 9 },
  { code: "+40", flag: "\u{1F1F7}\u{1F1F4}", name: "RO", label: "Romania", maxDigits: 9 },
  { code: "+359", flag: "\u{1F1E7}\u{1F1EC}", name: "BG", label: "Bulgaria", maxDigits: 9 },
  { code: "+385", flag: "\u{1F1ED}\u{1F1F7}", name: "HR", label: "Croatia", maxDigits: 9 },
  { code: "+381", flag: "\u{1F1F7}\u{1F1F8}", name: "RS", label: "Serbia", maxDigits: 9 },
  { code: "+370", flag: "\u{1F1F1}\u{1F1F9}", name: "LT", label: "Lithuania", maxDigits: 8 },
  { code: "+371", flag: "\u{1F1F1}\u{1F1FB}", name: "LV", label: "Latvia", maxDigits: 8 },
  { code: "+372", flag: "\u{1F1EA}\u{1F1EA}", name: "EE", label: "Estonia", maxDigits: 8 },
  { code: "+420", flag: "\u{1F1E8}\u{1F1FF}", name: "CZ", label: "Czech Republic", maxDigits: 9 },
  { code: "+421", flag: "\u{1F1F8}\u{1F1F0}", name: "SK", label: "Slovakia", maxDigits: 9 },
  { code: "+36", flag: "\u{1F1ED}\u{1F1FA}", name: "HU", label: "Hungary", maxDigits: 9 },
  { code: "+7", flag: "\u{1F1F7}\u{1F1FA}", name: "RU", label: "Russia", maxDigits: 10 },
  { code: "+234", flag: "\u{1F1F3}\u{1F1EC}", name: "NG", label: "Nigeria", maxDigits: 10 },
  { code: "+27", flag: "\u{1F1FF}\u{1F1E6}", name: "ZA", label: "South Africa", maxDigits: 9 },
  { code: "+254", flag: "\u{1F1F0}\u{1F1EA}", name: "KE", label: "Kenya", maxDigits: 9 },
  { code: "+233", flag: "\u{1F1EC}\u{1F1ED}", name: "GH", label: "Ghana", maxDigits: 9 },
  { code: "+20", flag: "\u{1F1EA}\u{1F1EC}", name: "EG", label: "Egypt", maxDigits: 10 },
  { code: "+212", flag: "\u{1F1F2}\u{1F1E6}", name: "MA", label: "Morocco", maxDigits: 9 },
  { code: "+1876", flag: "\u{1F1EF}\u{1F1F2}", name: "JM", label: "Jamaica", maxDigits: 7 },
  { code: "+1658", flag: "\u{1F1EF}\u{1F1F2}", name: "JM", label: "Jamaica (658)", maxDigits: 7 },
  { code: "+61", flag: "\u{1F1E6}\u{1F1FA}", name: "AU", label: "Australia", maxDigits: 9 },
  { code: "+64", flag: "\u{1F1F3}\u{1F1FF}", name: "NZ", label: "New Zealand", maxDigits: 9 },
  { code: "+353", flag: "\u{1F1EE}\u{1F1EA}", name: "IE", label: "Ireland", maxDigits: 9 },
];

function parsePhone(fullNumber) {
  if (!fullNumber) return { code: "+1", number: "" };
  const str = fullNumber.replace(/\s/g, "");
  for (const c of [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length)) {
    if (str.startsWith(c.code)) {
      return { code: c.code, number: str.slice(c.code.length) };
    }
  }
  if (str.startsWith("+")) {
    const match = str.match(/^(\+\d{1,4})(.*)/);
    if (match) return { code: match[1], number: match[2] };
  }
  return { code: "+1", number: str.replace(/^\+/, "") };
}

export function PhoneInput({ value, onChange, placeholder, className, dataTestId }) {
  const parsed = parsePhone(value);
  const [selectedCode, setSelectedCode] = useState(parsed.code);
  const [localNumber, setLocalNumber] = useState(parsed.number);
  const [showCodes, setShowCodes] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const p = parsePhone(value);
    setSelectedCode(p.code);
    setLocalNumber(p.number);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setShowCodes(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const emitChange = (code, num) => {
    onChange(code + num);
  };

  const currentMax = (COUNTRY_CODES.find(c => c.code === selectedCode) || {}).maxDigits || 15;

  // Pretty-format the raw digits for display (US-style bracketing for +1 country codes)
  const formatDisplay = (digits, code) => {
    if (!digits) return "";
    if (code === "+1") {
      // (XXX) XXX-XXXX
      const a = digits.slice(0, 3);
      const b = digits.slice(3, 6);
      const c = digits.slice(6, 10);
      if (digits.length <= 3) return `(${a}`;
      if (digits.length <= 6) return `(${a}) ${b}`;
      return `(${a}) ${b}-${c}`;
    }
    if (code === "+1876" || code === "+1658") {
      // XXX-XXXX
      const b = digits.slice(0, 3);
      const c = digits.slice(3, 7);
      return digits.length <= 3 ? b : `${b}-${c}`;
    }
    return digits;
  };

  const handleNumberChange = (e) => {
    const raw = e.target.value.replace(/[^\d]/g, "").slice(0, currentMax);
    setLocalNumber(raw);
    emitChange(selectedCode, raw);
  };

  const selectCountry = (c) => {
    // If user switches to a country with a stricter cap, trim excess digits
    const trimmed = localNumber.slice(0, c.maxDigits || 15);
    setSelectedCode(c.code);
    setShowCodes(false);
    setSearch("");
    setLocalNumber(trimmed);
    emitChange(c.code, trimmed);
  };

  const currentCountry = COUNTRY_CODES.find(c => c.code === selectedCode) || COUNTRY_CODES[0];
  const filtered = search
    ? COUNTRY_CODES.filter(c => c.label.toLowerCase().includes(search.toLowerCase()) || c.code.includes(search) || c.name.toLowerCase().includes(search.toLowerCase()))
    : COUNTRY_CODES;

  return (
    <div className="relative flex" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setShowCodes(!showCodes)}
        className={`flex items-center gap-1 px-2.5 border border-r-0 rounded-l-xl bg-gray-50 hover:bg-gray-100 transition-colors min-w-[80px] justify-center ${className?.includes("h-12") ? "h-12" : "h-10"}`}
        data-testid={`${dataTestId || "phone"}-country-btn`}
      >
        <span className="text-base">{currentCountry.flag}</span>
        <span className="text-xs font-medium text-gray-700">{selectedCode}</span>
        <ChevronDown className="w-3 h-3 text-gray-400" />
      </button>
      <Input
        type="tel"
        inputMode="numeric"
        value={formatDisplay(localNumber, selectedCode)}
        onChange={handleNumberChange}
        placeholder={placeholder || (selectedCode === "+1" ? "(555) 123-4567" : "Phone number")}
        className={`rounded-l-none ${className || ""}`}
        data-testid={dataTestId}
        maxLength={selectedCode === "+1" ? 14 : (selectedCode === "+1876" || selectedCode === "+1658" ? 8 : currentMax + 3)}
      />

      {showCodes && (
        <div className="absolute top-full left-0 z-50 mt-1 w-72 bg-white border rounded-xl shadow-xl max-h-64 overflow-hidden" data-testid="country-code-dropdown">
          <div className="p-2 border-b sticky top-0 bg-white">
            <Input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search country..."
              className="h-8 text-sm"
              autoFocus
            />
          </div>
          <div className="overflow-y-auto max-h-48">
            {filtered.map((c, i) => (
              <button
                key={`${c.name}-${i}`}
                type="button"
                onClick={() => selectCountry(c)}
                className={`w-full text-left px-3 py-2 hover:bg-blue-50 flex items-center gap-2 text-sm ${c.code === selectedCode ? "bg-blue-50 font-medium" : ""}`}
              >
                <span>{c.flag}</span>
                <span className="flex-1">{c.label}</span>
                <span className="text-xs text-gray-500">{c.code}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
